import React from "react";

import { isEqual } from "lodash";
import { useSelector } from "react-redux";

import { Tooltip } from "components/Form/FormikControls/Tooltip";
import { ReadOnly } from "components/ReadOnly";
import { TabLabel } from "components/TabSelector";
import { DefaultTab } from "components/TabSelector/TabRow";

import theme from "constants/theme";

import { getIsRolePermissionsEnabled } from "selectors";

import { useHasTemporaryBusinessesPermission } from "hooks";

// Wraps the whole label so hovering the attentionInfo dot shows the summary too.
const AttentionTabLabel = ({ summary, ...props }) =>
  summary ? (
    <Tooltip
      title={summary.map(line => (
        <div key={line}>{line}</div>
      ))}
      iconPadding={0}
    >
      <TabLabel {...props} />
    </Tooltip>
  ) : (
    <TabLabel {...props} />
  );

export const SecurityTrimmedNavigationTab = props => {
  const { attentionInfoSelector, hasPermissionSelector, title, ...tabProps } =
    props;
  const hasPermission = useSelector(state =>
    // Not all Roles user permissions yet. Only perform permission tests for Roles with the permissions machinery enabled on them
    getIsRolePermissionsEnabled(state) ? hasPermissionSelector(state) : true,
  );
  const hasTemporaryBusinesses = useHasTemporaryBusinessesPermission();
  const attentionInfo = useSelector(
    state =>
      typeof attentionInfoSelector === "function"
        ? attentionInfoSelector(state, hasTemporaryBusinesses)
        : null,
    isEqual,
  );
  if (!hasPermission) {
    return null;
  }

  const tabText = (
    <>
      <ReadOnly readOnly={!hasPermission} showLock /> {title}
    </>
  );

  const attentionProps = attentionInfoSelector
    ? {
        TabLabelComponent: AttentionTabLabel,
        tabLabelComponentProps: {
          color: attentionInfo ? theme.colors[attentionInfo.color] : null,
          summary: attentionInfo?.summary,
        },
      }
    : {};

  return (
    <DefaultTab
      {...tabProps}
      {...attentionProps}
      disabled={!hasPermission}
      title={tabText}
    />
  );
};
